/** Ventes BtoB de la période, avec modification et suppression. */

import type { BtobSale } from '@shared/types/btob';

import { formatDayShort, formatInteger, formatMoney } from '../lib/format';
import { Card } from './Card';

interface BtobSalesTableProps {
  sales: readonly BtobSale[];
  isSaving: boolean;
  onEdit: (sale: BtobSale) => void;
  onDelete: (sale: BtobSale) => void;
}

export function BtobSalesTable({ sales, isSaving, onEdit, onDelete }: BtobSalesTableProps) {
  return (
    <Card title="Ventes de la période" subtitle="Par date de facture, les plus récentes en premier" className="chart-grid__wide">
      {sales.length === 0 ? (
        <p className="empty">Aucune vente BtoB sur cette période — ajoutez-en une avec le formulaire.</p>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>Facture</th>
                <th>Magasin</th>
                <th>N°</th>
                <th className="num">Unités</th>
                <th className="num">CA HT</th>
                <th className="num">CA TTC</th>
                <th>Paiement</th>
                <th aria-label="Actions" />
              </tr>
            </thead>
            <tbody>
              {sales.map((sale) => (
                <tr key={sale.id}>
                  <td>{formatDayShort(sale.invoiceDate)}</td>
                  <td className="wrap">{sale.storeName}{sale.note ? <span className="kpi__hint"> — {sale.note}</span> : null}</td>
                  <td>{sale.invoiceNumber ?? '—'}</td>
                  <td className="num">{formatInteger(sale.units)}</td>
                  <td className="num">{formatMoney(sale.revenueHt, 'EUR', true)}</td>
                  <td className="num">{formatMoney(sale.revenueTtc, 'EUR', true)}</td>
                  <td>{sale.paymentDate ? formatDayShort(sale.paymentDate) : 'à encaisser'}</td>
                  <td>
                    <div className="row-actions">
                      <button type="button" className="btn btn--small" disabled={isSaving} onClick={() => onEdit(sale)}>
                        Modifier
                      </button>
                      <button type="button" className="btn btn--small" disabled={isSaving} onClick={() => onDelete(sale)}>
                        Supprimer
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
